import { useSyncExternalStore } from 'react';
import { getClipUpdateStatus, pendingEditsStore } from '@/stores/pendingEditsStore';

export const useClipPendingUpdate = ({ clipId }: { clipId: string }) => {
  const pendingUpdates = useSyncExternalStore(pendingEditsStore.subscribe, pendingEditsStore.getSnapshot);

  const clipUpdateStatus = getClipUpdateStatus(clipId, pendingUpdates);
  return {
    status: clipUpdateStatus
  };
};
